import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../loader-overlay/loader-overlay.component';
import {Component, OnInit, inject, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgGoogleChartsComponent } from '../ng-google-charts/ng-google-charts.component';
import $ from 'jquery';
import BusinessRestServices from "../../services/business-rest.service";
import Session from "../../utils/session.service";
import DialogServices from "../../services/dialog.service";
import { ModalSafetySurveyResultsComponent } from "../modal-safety-survey-results/modal-safety-survey-results.component";
import { HrEmployeeSurveyPopoverComponent } from "../hr-employee-survey-popover/hr-employee-survey-popover.component";

@Component({
	standalone: true,
	selector: 'modal-survey-analytics',
	templateUrl: './modal-survey-analytics.component.html',
	imports: [
		CommonModule, TranslatePipe, LoaderOverlayComponent, NgGoogleChartsComponent, HrEmployeeSurveyPopoverComponent
	]
})
export class ModalSurveyAnalyticsComponent implements OnInit {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalSurveyAnalyticsComponent>);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private data = inject(MAT_DIALOG_DATA);
	private session: Session = inject(Session);
	@ViewChild(HrEmployeeSurveyPopoverComponent) popoverComponent: HrEmployeeSurveyPopoverComponent;


	vm: any = undefined;
	tooltipVisible: boolean = false;
	tooltipText: string = 'text';
	tooltipX: number = 0;
	introductionFeedback: string = '';
	legendItems = [];
	colors = [];

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);

		this.vm.filterNonRespondentUsersPercentageText = this.filterNonRespondentUsersPercentageText;
		this.vm.filterNonRespondentUsersText = this.filterNonRespondentUsersText;
		this.vm.close = this.close;
		this.vm.getSectionsData = this.getSectionsData;
		this.vm.showTooltip = this.showTooltip;
		this.vm.hideTooltip = this.hideTooltip;
		this.vm.formatScoreValue = this.formatScoreValue;
		this.vm.getBackgroundColor = this.getBackgroundColor;
		this.vm.getProgressBarWidth = this.getProgressBarWidth;
		this.vm.filterText = this.filterText;
		this.vm.openFullDescription = this.openFullDescription;
		this.vm.getTranslationTextForPopover = this.getTranslationTextForPopover;

		this.vm.tooltipVisible = this.tooltipVisible;
		this.vm.tooltipText = this.tooltipText;
		this.vm.tooltipX = this.tooltipX;

		this.colors = this.getColors();

		this.initialize();
		this.getSectionsData();
	}

	initialize() {
		var w: any = $(window).width();
		this.vm.isSmallSizeWindow = (w ? w <= 768 : false);
		this.vm.titleFontSize = this.vm.isSmallSizeWindow ? '16px' : '22px'
		this.vm.riskLevelUsage = this.vm.surveyData.riskLevelUsages ? this.vm.surveyData.riskLevelUsages : {};
		this.vm.riskLevelUsage = this.vm.riskLevelUsage.map(function(item) {
		    if (!item.userCount) item.userCount = 0;
		    return item;
		});
		this.vm.user = this.session.getSession().user;
		this.vm.language = this.vm.user.deviceLanguage || 'et_EE';
		var totalUserCount = this.vm.riskLevelUsage.reduce(function(sum, group) {
		    return sum + group.userCount;
		}, 0);
		this.vm.showNoContentMessage = Object.keys(this.vm.riskLevelUsage).length === 0 || totalUserCount === 0;
		this.vm.usersWhoNotCompleted = this.vm.surveyData.sentCount - this.vm.surveyData.respondedCount;
		this.vm.getDistributionOfUsageGraph = (value) => {
		    this.vm.distributionOfUsageGraph = value;
		};
		const surveyName = this.vm.surveyData.questionnaire.translation.translationTextName ? this.vm.surveyData.questionnaire.translation.translationTextName : this.vm.surveyData.questionnaire.description;
		this.vm.surveyTitle = this.vm.surveyData.groupName ? this.vm.surveyData.groupName + ' - ' + surveyName : surveyName;
		this.vm.isPsychologicalSafetySurvey = this.vm.surveyData.questionnaire.codeName === 'DOM-SAFETY'

		if(this.vm.isPsychologicalSafetySurvey) {
			this.getDataForPsychologicalSafetySurvey();
		} else {
			if (!this.vm.showNoContentMessage) {
				var userCount = 0;

				var employeesByRiskFailure =
					[
						['Risk level of failure', 'Count of employees'],
						[this.angularFilterHelperService.translate('Surveys.Did_Not_Take_Part'), this.vm.usersWhoNotCompleted]
					]
						.concat(
							this.vm.riskLevelUsage.map((item) => {
								if (item['userCount']) ++userCount;
								return [this.getRiskLevelLabel(item['riskLevel']), item['userCount']]
							}));
				this.buildPieChart(employeesByRiskFailure || [], userCount);
				this.legendItems = this.prepareLegendItems(employeesByRiskFailure);
			}
		}
		
		this.vm.initialized = true;
	}

	getRiskLevelLabel(riskLevel) {
		if(this.vm.isPsychologicalSafetySurvey) {
			if (riskLevel === 2) {
				return this.angularFilterHelperService.translate('Surveys.No_Risk');
			} else if (riskLevel === 6) {
				return this.angularFilterHelperService.translate('Surveys.Low_Risk');
			} else if (riskLevel === 10) {
				return this.angularFilterHelperService.translate('Surveys.Medium_Risk');
			} else if (riskLevel === 14) {
				return this.angularFilterHelperService.translate('Surveys.Very_High_Risk');
			}
		} else {
			if (riskLevel === 2) {
				return this.angularFilterHelperService.translate('Surveys.No_Risk');
			} else if (riskLevel === 6) {
				return this.angularFilterHelperService.translate('Surveys.Low_To_Medium_Risk');
			} else if (riskLevel === 10) {
				return this.angularFilterHelperService.translate('Surveys.Medium_Risk');
			} else if (riskLevel === 14) {
				return this.angularFilterHelperService.translate('Surveys.Medium_To_High_Risk');
			} else if (riskLevel === 18) {
				return this.angularFilterHelperService.translate('Surveys.Very_High_Risk');
			}
		}
	}

	filterNonRespondentUsersText() {
		return this.angularFilterHelperService.translate('Surveys.Did_Not_Take_Part').replace('%s', this.vm.usersWhoNotCompleted);
	}

	filterNonRespondentUsersPercentageText() {
		return this.angularFilterHelperService.translate('Surveys.Employees').replace('%s', ((this.vm.usersWhoNotCompleted / this.vm.surveyData.sentCount) * 100).toFixed(0));
	}

	showTooltip(event: MouseEvent, text: string): void {
		this.vm.tooltipText = text;
		this.vm.tooltipVisible = true;

		const element = (event.target as HTMLElement).getBoundingClientRect();
		this.vm.tooltipX = element.left - 250;
	}

	hideTooltip(): void {
		this.vm.tooltipVisible = false;
	}

	truncate(text, size) {
		return text.length > size ? text.slice(0, size - 1) + "…" : text;
	}

	buildPieChart(employeesByRiskFailure, userCount) {
		this.vm.pieChartOptions = {
			chartType: 'PieChart',
			dataTable: employeesByRiskFailure,
			options: {
				pieHole: 0.5,
				colors: this.getColors(),
				width: this.vm.isSmallSizeWindow ? 300 : 400,
				height: this.vm.isSmallSizeWindow ? 150 : 300,
				legend: {
					position: "none",
					textStyle: {
						fontSize: this.vm.isSmallSizeWindow ? 12 : 16,
						fontName: 'Titillium Web'
					}
				},
				pieSliceText: userCount > 1 ? "value-and-percentage" : "none",
				tooltip: {
					text: 'value-and-percentage',
					textStyle: {
						fontSize: this.vm.isSmallSizeWindow ? 12 : 16,
						fontName: 'Titillium Web'
					}
				},
				pieSliceTextStyle: {
					fontSize: this.vm.isSmallSizeWindow ? 12 : 16,
					color: 'black',
					fontName: 'Titillium Web'
				},
				chartArea: {
					height: "80%",
					width: "100%"
				}
			}
		}
	}

	prepareLegendItems(dataTable: any[]): any[] {
		return dataTable.slice(1).map((row, index) => ({
			label: row[0],
			value: row[1],
			color: this.colors[index]
		}));
	}

	getTranslationTextForPopover(item) {
		if (item.color === this.colors[1]) {
			return this.angularFilterHelperService.translate('Surveys.Hr_Green_Evaluation');
		} else if (item.color === this.colors[2]) {
			return this.angularFilterHelperService.translate('Surveys.Hr_Light_Green_Evaluation');
		} else if (item.color === this.colors[3]) {
			return this.angularFilterHelperService.translate('Surveys.Hr_Yellow_Evaluation');
		} else if (item.color === this.colors[4]) {
			return this.angularFilterHelperService.translate('Surveys.Hr_Orange_Evaluation');
		} else if (item.color === this.colors[5]) {
			return this.angularFilterHelperService.translate('Surveys.Hr_Red_Evaluation');
		}
	}
	close() {
		this.dialogRef.close(undefined);
	}

	filterText() {
		return this.angularFilterHelperService.translate('Surveys.Employees').replace('%s', this.vm.surveyData.sentCount);

	}

	getColors() {
		var colors = [];
		colors.push('#d5d2d2', '#287638', '#FF5733', '#fcd757', '#FFA500', '#f24a69');
		return colors;
	}

	getSectionsData() {
		if (this.vm.employeesByRiskFailure != null) {
			if(this.vm.isPsychologicalSafetySurvey) {
				this.vm.noRiskCount = this.vm.employeesByRiskFailure[1]?.[1] || 0; // 'No risk'
				this.vm.lowCount = this.vm.employeesByRiskFailure[2]?.[1] || 0; // 'Low risk'
				this.vm.mediumCount = (this.vm.employeesByRiskFailure[3]?.[1] || 0); // Medium risk
				this.vm.highCount = this.vm.employeesByRiskFailure[4]?.[1] || 0; // 'Very high risk'
			} else {
				this.vm.noRiskCount = this.vm.employeesByRiskFailure[1]?.[1] || 0; // 'No risk'
				this.vm.mediumCount = this.vm.employeesByRiskFailure[2]?.[1] || 0; // 'Medium risk'
				this.vm.highCount = this.vm.employeesByRiskFailure[3]?.[1] || 0; // 'Very high risk'
			}

			var totalResponded = this.vm.surveyData.respondedCount;


			if (totalResponded > 0) {
				this.vm.noRiskPercentage = ((this.vm.noRiskCount / totalResponded) * 100).toFixed(0);
				this.vm.lowPercentage = ((this.vm.lowCount / totalResponded) * 100).toFixed(0);
				this.vm.mediumPercentage = ((this.vm.mediumCount / totalResponded) * 100).toFixed(0);
				this.vm.highPercentage = ((this.vm.highCount / totalResponded) * 100).toFixed(0);
			}
		}
	}


	formatScoreValue(score) {
		return parseFloat(score).toFixed(1); // Rounded to 1 decimal place
	}

	getBackgroundColor(index: number): string {
		const colors = [
			'#590a8a',
			'#0000FF',
			'#006400',
			'#8FBC8F',
			'#fcd757',
			'#FFA500',
			'#f24a69'
		];

		return colors[index] || '#FFFFFF';
	}

	getProgressBarWidth(averageScore: number): number {
		return ((averageScore - 1) / 4) * 100;
	}

	getDataForPsychologicalSafetySurvey() {
		this.vm.initialized = false;
		this.businessRestServices.getDataForPsychologicalSurvey({id: this.vm.surveyData.id, language: this.vm.language},
			(response) => {
				this.vm.questions = response;
				
				// reverse 1,3,5 scores (inverted questions), in array 0,2,4 (use 6 minus score for reverting)
				this.vm.questions[0].averageScore = 6 - this.vm.questions[0].averageScore;
				this.vm.questions[2].averageScore = 6 - this.vm.questions[2].averageScore;
				this.vm.questions[4].averageScore = 6 - this.vm.questions[4].averageScore;
				
				this.vm.inclusionSafetyShow = this.vm.questions[2].averageScore > 3;
				this.vm.learnerSafetyShow = this.vm.questions[0].averageScore > 3 || this.vm.questions[4].averageScore > 3;
				this.vm.contributorSafetyShow = this.vm.questions[5].averageScore < 3 || this.vm.questions[6].averageScore < 3;
				this.vm.challengerSafetyShow = this.vm.questions[1].averageScore < 3 || this.vm.questions[3].averageScore < 3;
				this.vm.showIntroductionFeedback = this.vm.inclusionSafetyShow || this.vm.learnerSafetyShow || this.vm.contributorSafetyShow || this.vm.challengerSafetyShow;
				this.vm.introductionFeedback = this.angularFilterHelperService.translate('Surveys.Introduction_Feedback').replace(/\n/g, '<br><br>');
				this.vm.initialized = true;
			},
			(err) => {
				console.log(err);
				this.vm.initialized = true;
			}
		);
	}

	openFullDescription(safetyGroup) {
		this.dialogServices.show({
			controller: ModalSafetySurveyResultsComponent,
			safetyGroup: safetyGroup,
			width: '500px',
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}

}